import { Box } from '@mui/material';
import { DynamicFileManagementAccordion } from './dynamic-file-management-accordion';
import { Fragment, useState } from 'react';
import { useQuery } from 'react-query';
import { getDynamicDocumentationFileTemplates } from '../../../fetch';
import { Loader, Button } from '../../../components';
import { Add } from '@mui/icons-material';
import { DynamicFileManagementAddFile } from './dynamic-file-modal';

export const DynamicFileManagement = () => {
  const [isModalOpen, showModal] = useState<boolean>(false);
  const [refetchRecent, setRefetchRecent] = useState<boolean>(false);
  const {
    data,
    isLoading,
    refetch: fetchTemplates
  } = useQuery(['getDynamicDocumentationFileTemplates'], () =>
    getDynamicDocumentationFileTemplates()
  );

  if (isLoading) {
    return <Loader position="centered" type="inline" />;
  }
  return (
    <>
      <Box mt={1}>
        <Box display="flex" justifyContent="flex-end" mb={1}>
          <Button
            id="create-new-file"
            onClick={() => {
              showModal(true);
            }}
            color="primary"
            variant="contained"
            startIcon={<Add />}
          >
            Add File
          </Button>
        </Box>
        {data?.map(file => {
          return (
            <Fragment key={file.name}>
              <DynamicFileManagementAccordion
                file={file.name}
                isActive={file.isActive}
                refetchRecent={refetchRecent}
              />
            </Fragment>
          );
        })}
      </Box>
      <DynamicFileManagementAddFile
        open={isModalOpen}
        onClose={(shouldReload?: boolean) => {
          if (shouldReload) {
            fetchTemplates();
            setRefetchRecent(true);
            setTimeout(() => {
              setRefetchRecent(false);
            }, 1000);
          }
          showModal(false);
        }}
      />
    </>
  );
};
